import { links, Request } from '@app/client';

import { apiReturnResults } from '../../../apiFactory/apiReturn';
import { type ApiResult, type BaseParams, type Competition, type ResourceId } from '../../../common/structs';

export type UpdateCompetitionPlayerBudgetParams = { slug: string; userId: ResourceId; budget: number };
type UpdateCompetitionPlayerBudget = BaseParams & UpdateCompetitionPlayerBudgetParams;
export async function setPlayersBudget(
    params: UpdateCompetitionPlayerBudget,
): Promise<ApiResult<Competition['winners']>> {
    return Request.putRequest<Competition['winners']>({
        ...params,
        target: links.admin().competitions.single(params.slug).updateBudget(),
        query: {
            userId: params.userId,
            budget: params.budget,
        },
        value: {
            userId: params.userId,
            budget: params.budget,
        },
    });
}
export const callSetPlayerBudget = (params: UpdateCompetitionPlayerBudget) =>
    apiReturnResults<Competition['winners']>(setPlayersBudget, params);
